import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { FormattedAdditionalFee } from '@wix/pricing-plans-tpa-api';
import { CreateCurrencyFormatter } from '@wix/yoshi-flow-editor';
import { getFormattedPriceData } from '../hooks';

export function getFormattedAdditionalFees(params: {
  plan: PublicPlan;
  locale?: string;
  createCurrencyFormatter: CreateCurrencyFormatter;
  hideTrailingFractionZeroes?: boolean;
}): FormattedAdditionalFee[] {
  const { plan, locale, createCurrencyFormatter, hideTrailingFractionZeroes } = params;
  if (!plan.pricing?.feeConfigs?.length) {
    return [];
  }

  return plan.pricing.feeConfigs.map((fee) => {
    const formatted = getFormattedPriceData({
      createCurrencyFormatter,
      locale,
      value: fee.fee?.amount,
      currency: plan.pricing?.price?.currency,
      hideTrailingFractionZeroes,
    });

    return { name: fee.fee?.name!, amount: `${formatted.fullPrice}` };
  });
}
